import { render, staticRenderFns } from "./user_amount.vue?vue&type=template&id=39827058&"
import script from "./user_amount.vue?vue&type=script&lang=js&"
export * from "./user_amount.vue?vue&type=script&lang=js&"
import style0 from "./user_amount.vue?vue&type=style&index=0&id=39827058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports